import { createContext, useCallback, useContext, useMemo, useReducer } from 'react';
import { initialState } from './initialState';
import { reducer } from './reducer';
import { TAppFormActions, TAppFormsContext, TAppFormState } from './types';

const AppFormContext = createContext<TAppFormsContext | undefined>(undefined);

const AppFormsProvider = ({ children }: { children: React.ReactElement }) => {
  const [state, dispatch] = useReducer<(state: TAppFormState, action: TAppFormActions) => TAppFormState>(
    reducer,
    initialState
  );

  const handleAction = useCallback((data: TAppFormActions) => {
    dispatch(data);
  }, []);

  const context = useMemo(() => ({ ...state, handleAction }), [state, handleAction]);

  return <AppFormContext.Provider value={context}>{children}</AppFormContext.Provider>;
};

const useAppForms = () => {
  const context = useContext(AppFormContext);
  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};

export { AppFormsProvider, useAppForms };
